import { useEffect, useState } from 'react';
import { BulletinStatus } from '@alucio/aws-beacon-amplify/src/models';
import { useSelector } from 'src/state/redux';
import { useCurrentUser } from 'src/state/redux/selector/user';
import { ROUTES } from 'src/router/routeDef';
import { canManageBulletins, getRecentBulletins } from './bulletin.utils';

export function useBulletins() {
  const { userProfile } = useCurrentUser();
  const { records, hydrated } = useSelector((state) => state.bulletin);
  const [, refreshTime] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => refreshTime((value) => value + 1), 60000);
    return () => clearInterval(timer);
  }, []);
  const canRead = !!userProfile && !!ROUTES.BULLETIN.ALLOWED_ROLES?.some((role) =>
    role === userProfile.role || userProfile.additionalRoles?.some((additionalRole) => additionalRole === role));
  const canManage = canManageBulletins(userProfile);
  const drafts = canManage
    ? records.filter((post) => post.tenantId === userProfile?.tenantId && post.status === BulletinStatus.DRAFT)
      .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))
    : [];
  return {
    drafts,
    bulletins: getRecentBulletins(records, userProfile?.tenantId, new Date()),
    hydrated,
    user: userProfile,
    canRead,
    canManage,
    name: 'Bulletin',
  };
}
